import { Helmet } from 'react-helmet-async';
import RecieverListView from 'src/sections/reciever/view/reciever-list-view';

export default function RecieverListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Receiver</title>
      </Helmet>

      <RecieverListView />
    </>
  );
}
